import rp from 'request-promise';
import config from '../../config';
import store from '../../store';

let getBaseUrl = () => {
    return config.apiUrl;
}

let getBearerToken = () => {
    return `Bearer ${store.getters['auth/currentAuthenticatedUser'].signInUserSession.idToken.jwtToken}`
}

const GPEDataService = {
    list: async (filter={}, for_download=false) => {
        try {
            let requestOptions = {
                url: getBaseUrl() + 'v2/gas_phase_energy',
                qs: {
                    'filter': JSON.stringify(filter),
                    for_download
                },
                json: true,
                method: 'GET'
            };

            let response = await rp( requestOptions );
        
            return response;
        } catch (error) {
            console.error('GPEDataService.list error', error)
        }
    },
    get_search_criteria: async () => {
        let requestOptions = {
            url: getBaseUrl() + 'v2/gas_phase_energy_search_criteria',
            json: true,
            method: 'GET'
        };

        let response = await rp( requestOptions );

        return response;
    },

    
}

export { GPEDataService };
